<template>
  <div class="mobile-cart-full">
    <brand-info></brand-info>
    <template v-if="!is_customer_logged_in">
      <checkout-login-form ref="checkoutLoginForm"></checkout-login-form>
      <cart-panel v-if="isFloorTableAvailable.table_id"></cart-panel>
    </template>
    <template v-else>
      <cart-panel></cart-panel>
      <delivery-detail v-if="!isFloorTableAvailable.table_id"></delivery-detail>
    </template>
    <div
      class="mobile-delivery"
      v-if="availableStores && availableStores.length > 1"
    >
      <store-selector></store-selector>
    </div>
    <div class="mobile-delivery" v-if="!isFloorTableAvailable.table_id">
      <delivery-time v-if="currentBrand.schedule_order"></delivery-time>
    </div>
    <items></items>
    <coupon> </coupon>
    <cashback> </cashback>
    <order-info-mobile @checkout="validateForms"></order-info-mobile>
  </div>
</template>

<script>
import StoreSelector from '@/components/Blocks/Payment/StoreSelector'
import { mapGetters } from 'vuex'
import BrandInfo from './MobileCart/BrandInfo'
import CartPanel from './MobileCart/CartPanel'
import DeliveryDetail from './MobileCart/DeliveryDetail'
import Items from './MobileCart/Items'
import OrderInfoMobile from './MobileCart/OrderInfoMobile'
import Cashback from '@/components/Blocks/Payment/Cashback.vue'
import CheckoutLoginForm from '@/components/Blocks/Payment/CheckoutLoginform'
import Coupon from '@/components/Blocks/Payment/Coupon'

import { isObjectEmpty, objectToString } from '@/utils/main_utils'
import DeliveryTime from '@/components/Blocks/Payment/DeliveryTime'

export default {
  name: 'MobileCart',
  components: {
    DeliveryTime,
    BrandInfo,
    CartPanel,
    DeliveryDetail,
    Items,
    Cashback,
    OrderInfoMobile,
    CheckoutLoginForm,
    Coupon,
    StoreSelector,
  },

  computed: {
    ...mapGetters([
      'is_customer_logged_in',
      'guest_checkout',
      '_T',
      'brandStoreParams',
      'brandStoreRoute',
      'customer_address',
      'isFloorTableAvailable',
      'availableStores',
      'currentBrand',
      'currentStore',
    ]),
  },
  methods: {
    validateForms() {
      if (this.guest_checkout) {
        let guestErrors = this.$refs.checkoutLoginForm.$refs.guest_checkout_form.validateForm()

        if (!isObjectEmpty(guestErrors)) {
          this.$store.dispatch('showNotification', {
            text: objectToString(guestErrors, '</br>'),
            status: 'error',
          })
          return false
        }
      }

      if (!this.customer_address) {
        this.$store.dispatch('showNotification', {
          text: this._T('Please provide Delivery Address'),
          status: 'error',
        })
        return Promise.reject(this._T('Please provide Delivery Address'))
      }

      this.$store
        .dispatch('validateCheckout')
        .then(() => {
          this.$router.push({
            name: this.brandStoreRoute('checkout'),
            params: {
              ...this.brandStoreParams,
            },
          })
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log('checkout validation was failed', error)
          this.$store.dispatch('stopProcess', this.process)
        })
    },
  },
  watch: {
    currentStore(newVal) {
      if (newVal) {
        this.$store.dispatch('calculateLoyaltyAmountForItem')
      }
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 575px) {
  .mobile-delivery {
    padding-top: $px10;
    background: $white;
    margin-top: $px20;
    .title {
      padding-left: 14px;
    }
    .delivery-time {
      padding-left: 25px;
    }
    .w-100 {
      max-width: 90%;
      margin-left: 5%;
      margin-bottom: $px20;
    }
  }
  .body-rtl {
    .mobile-delivery {
      .title {
        padding-right: 14px;
      }
      .delivery-time {
        padding-right: 25px;
      }
      .w-100 {
        margin-right: 5%;
      }
    }
  }
}
.body-rtl {
  .mobile-cart-full {
    .cart-detail-box {
      .added-product {
        @media (max-width: 575px) {
          li {
            .qty-box {
              left: 0;
              right: unset;
            }
            .detail {
              margin-right: $px18;
              margin-left: unset;
              text-align: right;
              h6 {
                span {
                  float: left;
                }
              }
              a {
              }
            }
          }
        }
      }
    }
  }
}
.mobile-cart-full {
  width: $px375;
  height: 100vh;
  @media (max-width: 575px) {
    // overflow-x: hidden;
    height: auto;
  }
  /* --starting queries for iPhone issues */
  @media screen and (device-aspect-ratio: 2/3) {
    height: 100% !important;
    overflow-y: scroll !important;
  }
  @media screen and (device-aspect-ratio: 40/71) {
    height: 100% !important;
    overflow-y: scroll !important;
  }
  @media screen and (device-aspect-ratio: 375/667) {
    height: 100% !important;
    overflow-y: scroll !important;
  }
  @media screen and (device-aspect-ratio: 9/16) {
    height: 100% !important;
    overflow-y: scroll !important;
  }
  /* --ending queries for iPhone issues */
  background-color: $light-border;
  box-shadow: 0 0 $px8 0 $light-font;
  .cart-detail-box {
    padding: $px15 $px20;
    background-color: $white;
    margin-top: $px12;
    .title {
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.02em;
      color: $font-color;
      text-transform: capitalize;
      span {
        float: right;
      }
    }
    .delivery-detail {
      align-items: center;
      display: flex;
      ul {
        align-items: center;
        display: flex;
        li {
          align-items: center;
          display: flex;
          + li {
            margin-left: $px22;
          }
        }
        &.pickup-time {
          border: $px1 solid $light-border;
          border-radius: $px4;
          padding: $px5 0;
          li {
            padding: $px5;
            width: 33.33%;
            + li {
              border-left: $px1 solid $light-border;
              margin-left: 0;
            }
          }
          span {
            margin: 0 auto;
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            letter-spacing: 0.005em;
            color: $font-color;
          }
        }
      }
      span {
        font-weight: normal;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.02em;
        color: $font-color;
        margin-left: $px5;
      }
      .btn-change {
        margin-top: $px15;
        width: 100%;
        background: $light-border;
        border-radius: $px4;
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        color: $color-primary;
        text-transform: capitalize;
        padding: $px10;
      }
      .down-select {
        margin-left: auto;
      }
    }
    .added-product {
      li {
        display: flex;
        position: relative;
        min-height: $px87;
        .detail {
          margin-left: $px18;
          width: 100%;
          h6 {
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            letter-spacing: 0.02em;
            color: $font-color;
            text-transform: capitalize;
            margin-bottom: $px2;
            span {
              float: right;
            }
          }
          p {
            max-width: $px180;
            font-weight: normal;
            font-size: $px13;
            line-height: $px16;
            letter-spacing: 0.5px;
            color: $light-font;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            margin-bottom: 0;
          }
          a {
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            letter-spacing: 0.02em;
            color: $warning-color;
            align-items: center;
            display: flex;
            margin-top: $px6;
            svg {
              margin-left: $px3;
            }
          }
        }
        .qty-box {
          margin-left: 0;
          position: absolute;
          right: 0;
          bottom: 0;
          .form-control {
            width: $px32;
            height: $px32;
          }
          .input-group {
            .btn {
              width: $px32;
            }
          }
        }
        + li {
          padding-top: $px20;
          margin-top: $px20;
          border-top: $px1 solid $light-border;
        }
      }
      .btn-add {
        width: 100%;
        border: $px1 dashed $light-border;
        border-radius: $px4;
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.04em;
        color: $color-primary;
        background-color: $white;
        margin-top: $px30;
        text-transform: capitalize;
        padding: $px15;
      }
    }
    .cashback {
      width: 100%;
      padding-top: 0;
      border-top: none;
      h4 {
        margin-bottom: calc(
          #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        font-weight: 600;
      }
      .summary-card {
        padding: calc(
          #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        background-color: $white;
        border-radius: $px4;
        border: $px1 solid $dark-border;
        display: block;
        .item-content {
          h5 {
            font-weight: 600;
            margin-bottom: 0;
          }
          ul {
            width: 80%;
            li {
              font-weight: 600;
              font-size: $px12;
              line-height: $px15;
              letter-spacing: 0.5px;
              color: $light-font;
              i {
                font-size: $px5;
                vertical-align: middle;
                color: $warning-color;
              }
            }
          }
        }
        .text-right {
          h5 {
            margin-bottom: 0;
            font-weight: 600;
          }
        }
        + .summary-card {
          margin-top: $px10;
        }
      }
      .cashback-card {
        border: $px1 solid $light-border;
        border-radius: $px4;
        .media {
          padding: $px15;
          .media-body {
            padding-left: $px18;
            h6 {
              font-weight: 600;
              letter-spacing: 0.005em;
              margin-bottom: 0;
            }
            p {
              font-size: $px12;
              line-height: $px15;
              color: $light-font;
              margin-bottom: 0;
            }
          }
        }
        .cash-footer {
          border-top: $px1 solid $light-border;
          padding: $px8 $px20;
          h6 {
            font-weight: 600;
            font-size: $px12;
            line-height: $px15;
            letter-spacing: 0.5px;
            color: $light-font;
            margin-bottom: 0;
            span {
              float: right;
              color: $font-color;
            }
          }
        }
      }
      .chk-outline {
        margin-top: $px10;
        .checkbox_animated {
          margin-right: $px12;
          &:after {
            top: -$px1;
            width: $px18;
            height: $px18;
          }
          &:before {
            left: $px3;
            top: $px4;
          }
        }
        label {
          font-size: $px12;
          line-height: $px15;
          color: $black;
        }
      }
      ul {
        padding-top: calc(
          #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        li {
          display: block;
          h5 {
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            letter-spacing: 0.005em;
            color: $light-font;
          }
          span {
            float: right;
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            letter-spacing: 0.005em;
            color: $font-color;
          }
          &.cashback-point {
            span {
              color: $color-tertiary;
            }
          }
          + li {
            margin-top: $px14;
          }
        }
      }
    }
    .cart-checkout {
      .bill-amount {
        h4 {
          font-weight: bold;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.005em;
          color: $font-color;
          text-transform: capitalize;
          span {
            float: right;
          }
        }
      }
    }
    .img-detail-box {
      display: flex;
      align-items: center;
      width: 100%;
      .cart-img {
        width: $px70;
        height: $px70;
        border-radius: $px4;
        position: relative;
        overflow: hidden;
        margin-right: $px10;
        .cart-qty {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          background-color: $color-tertiary;
          font-weight: bold;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $white;
          text-align: center;
          padding: $px3;
        }
      }
      .cart-content {
        max-width: $px216;
        h6 {
          font-weight: bold;
          font-size: $px14;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $font-color;
          margin-bottom: $px4;
        }
        h5 {
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $light-font;
          margin-bottom: $px2;
        }
        .cart_price {
          font-weight: bold;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $light-font;
        }
      }
      .trash {
        margin-left: auto;
      }
    }
  }
  .checkout-login {
    .icon-main {
      display: none;
    }
    .media-body {
      margin: 0;
      background: #fff;
      .timeline-card {
        border: none;
        border-top: $px1 solid $dark-border;
        border-radius: 0;
      }
    }
  }
  &.show {
    display: block;
  }
}
.custom-tips-modal {
  display: none;
}
@media (max-width: 767px) {
  .mobile-cart-full {
    width: 100vw;
  }
}
</style>
